// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__CW-JB","label":"CategoryService_label__1J1yH","location":"CategoryService_location__2Be8o"};